import { Button } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

const ForgotPasswordSuccess = ({ handleBackToSignIn }) => {
  const { t } = useTranslation()

  return (
    <div className="login__forgot-password-container">
      <Text className="login__sign-in-label">
        {t('login.resetPassword.successTitle')}
      </Text>

      <Text>{t('login.resetPassword.successMessage')}</Text>

      <Button
        className="login__submit-button"
        onClick={handleBackToSignIn}
        style={{ marginTop: '1.5rem' }}
        type="primary"
      >
        {t('login.resetPassword.backToSignIn')}
      </Button>
    </div>
  )
}

ForgotPasswordSuccess.propTypes = {
  handleBackToSignIn: PropTypes.func.isRequired,
}

export default ForgotPasswordSuccess
